// removed by extract-text-webpack-plugin
module.exports = {"buttonContainer":"buttonContainer__3eSe-","capturedImage":"capturedImage__1THpL","container":"container__4SJd9","video":"video__3Cy_z"};


//////////////////
// WEBPACK FOOTER
// ./routes/takePicture/style.css
// module id = 7ojV
// module chunks = 1